module.exports = __webpack_public_path__ + "img/granfront_osaka_banner.8068dc9d.jpg";